import api from "@/api/index";
import restfulApi from "@/api/restfulApi";

export default {

  /**
   *
   * @param link
   * @returns Promise
   */
  getHouseElements(link) {
    return api.get(link).then(response => response.data)
  },

  /**
   *
   * @returns Promise
   */
  getCategories() {
    return api.get(restfulApi.getLink('categories', 'GET')).then(response => response.data)
  },

  /**
   *
   * @returns Promise
   */
  getElements() {
    return api.get(restfulApi.getLink('elements', 'GET')).then(response => response.data)
  },

  /**
   *
   * @returns Promise
   */
  getUnitValues() {
    return api.get(restfulApi.getLink('units', 'GET')).then(response => response.data)
  },

  /**
   *
   * @param link
   * @param elementData
   * @returns Promise
   */
  addElement(link, elementData) {
    return api.post(link, elementData).then(response => response.data)
  },

  /**
   *
   * @param link
   * @param elementData
   * @returns Promise
   */
  editElement(link, elementData) {
    return api.patch(link, elementData).then(response => response.data)
  },

  /**
   *
   * @param link
   * @returns Promise
   */
  deleteElement(link) {
    return api.delete(link).then(response => response.data)
  }
}
